import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class YellowActionsService {
  constructor(private http: HttpClient) {}
  getAllYellowsActions(params: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/yellow-actions', { params });
  }

  changeSequence(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/yellow-actions/updateSequence/`, { data });
  }

  updateVisibility(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/yellow-actions`, { data });
  }

  exportYellowActions(params: any) {
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
      params,
    };
    return this.http.post<HttpResponse<Blob>>('/v1/admin/yellow-actions/export-actions', params, options);
  }
}
